import { showErrorToast } from '@npco/zeller-design-system'
import { compose, last, prop, split } from 'ramda'

import { translate } from 'utils/translations'

export const displayDeleteImageErrorToast = () => {
  showErrorToast(translate('errorMessages.failedToRemoveImage'))
}

export const getFileNameWithExtension = (file: File) => {
  const getExtension = compose(last, split('/'), prop<'type', string>('type'))

  return `${file.name}.${getExtension(file)}`
}
